import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {fetchGetBackups, fetchRunBackup, fetchRestoreBackup, fetchDeleteBackup} from "./actions";
import {IBackupList} from "../api";

interface IBackupState extends IBackupList {
    isLoading: boolean;
    isRestoring: boolean;
}

const initialState: IBackupState = {
    enabled: true,
    database: "",
    items: [],
    isLoading: false,
    isRestoring: false,
};

const setList = (s: IBackupState, a: PayloadAction<IBackupList>) => {
    s.enabled = a.payload.enabled;
    s.database = a.payload.database;
    s.items = a.payload.items;
    s.isLoading = false;
};

export const BackupSlice = createSlice({
    name: "backup_slice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchGetBackups.pending, (s) => { s.isLoading = true; })
            .addCase(fetchGetBackups.fulfilled, setList)
            .addCase(fetchGetBackups.rejected, (s) => { s.isLoading = false; })
            .addCase(fetchRunBackup.pending, (s) => { s.isLoading = true; })
            .addCase(fetchRunBackup.fulfilled, setList)
            .addCase(fetchRunBackup.rejected, (s) => { s.isLoading = false; })
            .addCase(fetchDeleteBackup.pending, (s) => { s.isLoading = true; })
            .addCase(fetchDeleteBackup.fulfilled, setList)
            .addCase(fetchDeleteBackup.rejected, (s) => { s.isLoading = false; })
            .addCase(fetchRestoreBackup.pending, (s) => { s.isRestoring = true; })
            .addCase(fetchRestoreBackup.fulfilled, (s) => { s.isRestoring = false; })
            .addCase(fetchRestoreBackup.rejected, (s) => { s.isRestoring = false; });
    },
});

export default BackupSlice.reducer;
